import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CancelShipmentReasonMiniEntity } from '../../domain/entities/CancelShipmentReasonMiniEntity'

export class CancelShipmentReasonMiniModel extends CancelShipmentReasonMiniEntity {
  constructor(dataDto: CancelShipmentReasonMiniModel) {
    super()
    mapEntityProperties<CancelShipmentReasonMiniEntity>(this, dataDto)
  }
}
